import { NgModule, Injector, InjectionToken } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgGridModule } from 'ag-grid-angular';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog'
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './core/header/header.component';
import { ToolbarComponent } from './core/toolbar/toolbar.component';
import { OperatingprocedureComponent } from './page/operatingprocedure/operatingprocedure.component';
import { CategoriesComponent } from './page/categories/categories.component';
import { BtnCellRenderer } from './core/grid/btn-cell-render.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TaskComponent } from './page/task/task.component';
import { RouterModule } from '@angular/router';
import { TemplatesComponent } from './page/templates/templates.component';
import { SubtaskComponent } from './page/subtask/subtask.component';
import { AddCategoryDialogComponent } from './core/dialogs/add-category-dialog/add-category-dialog.component';
import { AddSubtaskDialogComponent } from './core/dialogs/add-subtask-dialog/add-subtask-dialog.component';
import { AddTaskDialogComponent } from './core/dialogs/add-task-dialog/add-task-dialog.component';
import { AddTemplateTaskDialogComponent } from './core/dialogs/add-template-task-dialog/add-template-task-dialog.component';
import { DeleteCategoryDialogComponent } from './core/dialogs/delete-category-dialog/delete-category-dialog.component';
import { HolidaysComponent } from './page/holidays/holidays.component';
import { FgaService } from './fga/fga.service';
import { provideApollo } from 'apollo-angular';
import { InMemoryCache } from '@apollo/client/cache';
//board
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { APP_INITIALIZER, inject, provideAppInitializer } from '@angular/core';
import {
  NgxUiLoaderModule,
  NgxUiLoaderConfig,
  SPINNER,
  POSITION,
  PB_DIRECTION,
} from "ngx-ui-loader";

import { AddHolidaysDialogComponent } from './core/dialogs/add-holidays-dialog/add-holidays-dialog.component';
import { AddOpDialogComponent } from './core/dialogs/add-op-dialog/add-op-dialog.component';
import { KpisComponent } from './page/kpis/kpis.component';
import { BoardComponent } from './page/board/board.component';

import { TaskStatusComponent } from './page/board/task-status/task-status/task-status.component';
import { TaskStatus2Component } from './page/board/task-status/task-status2/task-status2.component';
import { TaskStatus3Component } from './page/board/task-status/task-status3/task-status3.component';

import { NewTaskComponent } from './page/board/new-task/new-task.component';
import { PeriodTaskComponent } from './page/board/new-task/period-task/period-task.component';
import { FromTemplateComponent } from './page/board/new-task/from-template/from-template.component';
import { NewContingencyComponent } from './page/board/new-task/new-contingency/new-contingency.component';
import { WeeklyTaskComponent } from './page/board/new-task/weekly-task/weekly-task.component';
import { CreateContingencyComponent } from './page/board/new-task/create-contingency/create-contingency.component';
import { AddTemplateDialogComponent } from './core/dialogs/add-template-dialog/add-template-dialog.component';
import { DeleteTemplateDialogComponent } from './core/dialogs/delete-template-dialog/delete-template-dialog.component';
import { DeleteBoardTaskDialogComponent } from './core/dialogs/delete-board-task-dialog/delete-board-task-dialog.component';
import { FooterComponent } from './core/footer/footer.component';
import { DateFilterComponent } from './page/board/filter/date-filter/date-filter.component';
import { TeamsComponent } from './page/teams/teams.component';


//Msal
import { MsalService, MSAL_INSTANCE, MsalGuard, MsalInterceptor, MsalBroadcastService } from './msal';
import { IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG } from './msal/constants';
import { Constants } from './constants';
import { MsalInterceptorConfig } from './msal/msal.interceptor.config';
import { environment } from 'src/environments/environment';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import {
  MsalInterceptorConfiguration,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import { ContextMenuModule, MasterDetailModule } from 'ag-grid-enterprise';

ModuleRegistry.registerModules([
  AllCommunityModule,
  MasterDetailModule,
  ContextMenuModule
])
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.CLIENT_ID,
      authority: environment.TENANT_ID,
      redirectUri: environment.REDIRECT_URL
    }
  });
}
export const FGA_API_ENDPOINT = new InjectionToken<string>('FGA_API_ENDPOINT');
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(
    environment.REDIRECT_URL,
    environment.SCOPES
  );

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...environment.SCOPES],
    },
    loginFailedRoute: '/unauthorized',
  };
}
export function initializeMsal(instance: IPublicClientApplication): () => Promise<void> {
  return () => instance.initialize();
}

import { AddTeamDialogComponent } from './core/dialogs/add-team-dialog/add-team-dialog.component';
import { LateConfComponent } from './page/board/dialog/late-conf/late-conf.component';
import { MonthlyTaskComponent } from './page/board/new-task/monthly-task/monthly-task.component';
import { OnetimeTaskComponent } from './page/board/new-task/onetime-task/onetime-task.component';
import { StatusComponent } from './page/board/dialog/status/status.component';
import { DeleteTeamDialogComponent } from './core/dialogs/delete-team-dialog/delete-team-dialog.component';
import { SaveTeamDialogComponent } from './core/dialogs/save-team-dialog/save-team-dialog.component';
import { MyTasksComponent } from './page/my-tasks/my-tasks.component';
import { EditPeriodComponent } from './page/board/new-task/edit-period/edit-period.component';
import { EditOnetimeComponent } from './page/board/new-task/edit-onetime/edit-onetime.component';
import { CommonModule } from "@angular/common";
import { GridTextEditorComponent } from './core/grid/grid-text-edit.component';
import { createCustomElement } from '@angular/elements';
import { LandingComponent } from './page/landing/landing.component';
import { UploadTemplateComponent } from './page/templates/upload-template/upload-template.component';
import { LiosNavbarComponent } from './core/lios-navbar/lios-navbar.component';
import { UnauthorizedComponent } from './page/unauthorized/unauthorized.component';
import { AddParamsInterceptor } from './add-params.interceptor';
import { FgaModule } from './fga/fga.module';
import { BreadcrumbComponent } from './core/breadcrumb/breadcrumb.component';


const cntr = "center-center"
const ngxUiLoaderConfig: NgxUiLoaderConfig =
{
  "bgsColor": "red",
  "bgsOpacity": 0.5,
  "bgsPosition": "bottom-right",
  "bgsSize": 60,
  "bgsType": "ball-spin-clockwise",
  "blur": 5,
  "delay": 0,
  "fastFadeOut": true,
  "fgsColor": "red",
  "fgsPosition": cntr,
  "fgsSize": 60,
  "fgsType": "ball-spin-clockwise",
  "gap": 24,
  "logoPosition": cntr,
  "logoSize": 120,
  "logoUrl": "",
  "masterLoaderId": "master",
  "overlayBorderRadius": "0",
  "overlayColor": "rgba(40, 40, 40, 0.8)",
  "pbColor": "red",
  "pbDirection": "ltr",
  "pbThickness": 3,
  "hasProgressBar": true,
  "text": "",
  "textColor": "#FFFFFF",
  "textPosition": cntr,
  "maxTime": -1,
  "minTime": 300
}



@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    ToolbarComponent,
    OperatingprocedureComponent,
    CategoriesComponent,
    AddCategoryDialogComponent,
    BtnCellRenderer,
    TaskComponent,
    DeleteCategoryDialogComponent,
    AddTaskDialogComponent,
    TemplatesComponent,
    SubtaskComponent,
    AddSubtaskDialogComponent,
    AddTemplateTaskDialogComponent,
    HolidaysComponent,
    AddHolidaysDialogComponent,
    AddOpDialogComponent,
    KpisComponent,
    BoardComponent,
    TaskStatusComponent,
    TaskStatus2Component,
    TaskStatus3Component,
    NewTaskComponent,
    PeriodTaskComponent,
    FromTemplateComponent,
    NewContingencyComponent,
    WeeklyTaskComponent,
    CreateContingencyComponent,
    AddTemplateDialogComponent,
    DeleteTemplateDialogComponent,
    FooterComponent,
    DateFilterComponent,
    TeamsComponent,
    AddTeamDialogComponent, LateConfComponent, LandingComponent,
    DeleteBoardTaskDialogComponent,
    MonthlyTaskComponent,
    OnetimeTaskComponent,
    DeleteTeamDialogComponent,
    SaveTeamDialogComponent,
    StatusComponent,
    MyTasksComponent,
    EditPeriodComponent,
    EditOnetimeComponent,
    GridTextEditorComponent,
    UploadTemplateComponent,
    LiosNavbarComponent,
    UnauthorizedComponent
  ],
  bootstrap: [AppComponent], imports: [BrowserModule,
    AppRoutingModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    AgGridModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    BrowserAnimationsModule,
    FormsModule,
    MatDialogModule,
    RouterModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatProgressBarModule,
    MatSelectModule,
    MatCheckboxModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatTabsModule,
    FgaModule,
    BreadcrumbComponent], providers: [
      Constants,
      //{ provide: LocationStrategy },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: MsalInterceptor,
        multi: true
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AddParamsInterceptor,
        multi: true
      },
      {
        provide: MSAL_INSTANCE,
        useFactory: MSALInstanceFactory
      },
      {
        provide: MSAL_GUARD_CONFIG,
        useFactory: MSALGuardConfigFactory
      },
      {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useFactory: MSALInterceptorConfigFactory
      },
      provideAppInitializer(() => {
        const msalInstance = inject(MSAL_INSTANCE);
        return msalInstance.initialize();
      }),
      MsalService,
      MsalGuard,
      MsalBroadcastService,
      provideHttpClient(withInterceptorsFromDi()),
      provideApollo(() => {
        return { cache: new InMemoryCache() };
      }),
      { provide: FGA_API_ENDPOINT, useValue: environment.APM_DS_URI }
    ]
})
export class AppModule { }
